import React, { useRef, useEffect } from "react";
import * as ReactDOM from "react-dom";
import App from "./App";

const Root = () => {
    // In iOS click event doesn't trigger, if the event target doesn't have cursor:pointer
    // onClick={() => {}} is attached to a div which covers the whole document in order to use react's handler
    // as a fix for iOS devices
    const appRef = useRef(null);
    useEffect(() => {
        if (appRef.current) {
            const rootHTMLElement = ReactDOM.findDOMNode(appRef.current).parentNode;
            rootHTMLElement.addEventListener("click", () => {});
        }
    }, []);

    return <App ref={appRef} />;
};

export default Root;
